export function Filter() {
    var checkboxFilter = CheckboxFilter(),
        dateFilter = DateFilter(),
        maxRentFilter = RentFilter(),
        unitNumberFilter = UnitNumberFilter();

    return Object.create({
        setDateFilterValue: function(newDate) {
            dateFilter = DateFilter(newDate);
        },
        getDateFilterValue: function() {
            return dateFilter.value();
        },
        setMaxRentValue: function(maxRent) {
            maxRentFilter = RentFilter(maxRent);
        },
        getMaxRentValue: function() {
            return maxRentFilter.value();
        },
        setUnitNumberFilterValue: function(unitNumber) {
            unitNumberFilter = UnitNumberFilter(unitNumber);
        },
        getUnitNumberFilterValue: function() {
            return unitNumberFilter.value();
        },
        getCheckboxFilter: function() {
            return checkboxFilter;
        },
        run: function(collection) {
            var visible = [];

            collection.forEach(function(model) {
                var i,
                    filters = [dateFilter, maxRentFilter, checkboxFilter, unitNumberFilter];


                for (i = 0; i < filters.length; i++) {
                    if (!filters[i].run(model)) {
                        return;
                    }
                }

                visible.push(model);
            });

            return visible;
        },
        reset: function() {
            this.setDateFilterValue(null);
            this.setMaxRentValue(null);
            checkboxFilter.clear();
        }
    });
}

function DateFilter(date) {
    return Object.create({
        run: function(model) {
            return !date || model.getAvailableDate() <= date;
        },
        value: function() {
            return date;
        }
    });
}

function RentFilter(maxRent) {
    return Object.create({
        run: function(model) {
            if (maxRent == null) {
                return true;
            }

            return model.getMinimumRent() <= maxRent;
        },
        value: function() {
            return maxRent;
        }
    });
}

function CheckboxFilter() {
    var checkLists = [];

    return Object.create({
        run: function(model) {
            var i = 0;

            for (; i < checkLists.length; i++) {
                if (!checkLists[i].run(model)) {
                    return false;
                }
            }

            return true;
        },
        addList: function(name, property) {
            checkLists.push(Checklist(name, property));
        },
        addOption: function(listName, value) {
            var list = findList(listName);

            if (!list) {
                return false;
            }

            list.addCheckbox(value);
            return true;
        },
        toggle: function(listName, value) {
            var list = findList(listName);

            if (list) {
                return list.toggle(value);
            }

            return false;
        },
        clear: function() {
            checkLists.forEach(function(list) {
                list.clear();
            });
        },
        serialize: function() {
            return checkLists.map(function(list) {
                return list.serialize();
            });
        }
    });

    function findList(listName) {
        var list, i,
            found = false;

        for (i = 0; i < checkLists.length; i++) {
            list = checkLists[i];
            if (list.name() === listName) {
                found = true;
                break;
            }
        }

        if (!found) {
            return null;
        }

        return list;
    }
}

function Checklist(name, property) {
    var checkboxes = [];

    return Object.create({
        run: function(model) {
            var i,
                checked = getChecked(),
                prop = getProperty(model);

            if (!checked.length) {
                // If no boxes in the list are checked, everything matches...
                return true;
            }

            if (Array.isArray(prop)) {
                return compoundProperty(prop, checked);
            }

            for (i = 0; i < checked.length; i++) {
                if (checked[i].value() === prop) {
                    return true;
                }
            }

            return false;
        },
        name: function() {
            return name;
        },
        addCheckbox: function(value) {
            checkboxes.push(Checkbox(value));
        },
        toggle: function(value) {
            var found, checkbox, i;

            for (i = 0; i < checkboxes.length; i++) {
                checkbox = checkboxes[i];
                if (checkbox.value() === value) {
                    found = true;
                    break;
                }
            }

            if (found) {
                return checkbox.toggle();
            }

            return false;
        },
        clear: function() {
            checkboxes.forEach(function(box) {
                box.set(false);
            });
        },
        serialize: function() {
            var boxes = checkboxes.map(function(box) {
                var value = box.value();
                return {
                    value: value,
                    checked: box.isChecked(),
                    id: makeElementID(value)
                };
            });

            return {
                name: name,
                options: boxes
            };
        }
    });

    function getProperty(model) {
        if (model[property] && typeof model[property] === "function") {
            return model[property]();
        }

        return model.get(property);
    }

    function compoundProperty(property, checked) {
        // For array properties, we'll assume that at least one of our checked values needs to match at least one of the values in the list.
        var i = 0;

        for (; i < checked.length; i++) {
            if (property.indexOf(checked[i].value()) !== -1) {
                return true;
            }
        }

        return false;
    }

    function getChecked() {
        return checkboxes.filter(function(checkbox) {
            return checkbox.isChecked();
        });
    }
}

function Checkbox(value) {
    var isChecked = false;

    return Object.create({
        value: function() {
            return value;
        },
        isChecked: function() {
            return isChecked;
        },
        toggle: function() {
            isChecked = !isChecked;
            return isChecked;
        },
        set: function(checked) {
            isChecked = !!checked;
            return isChecked;
        }
    });
}

function UnitNumberFilter(unitNumber) {
    return Object.create({
        run: function(model) {
            if (!unitNumber) {
                return true;
            }

            return model.hasUnitNumber(unitNumber);
        },
        value: function() {
            return unitNumber;
        }
    });
}

function makeElementID(inputString) {
    return inputString.replace(/\W+/g, "_").replace(/^_+|_+$/g, "").toLowerCase();
}
